import React, { useState, useEffect } from 'react';

const AFFILIATE_API_URL = 'http://127.0.0.1:8000/affiliateur';

export default function AffiliateEditLink() {
  const [token, setToken] = useState(localStorage.getItem('affiliate_token'));
  const [codeAff, setCodeAff] = useState('');
  const [newCode, setNewCode] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (token) fetchCurrentCode();
  }, [token]);

  const fetchCurrentCode = async () => {
    try {
      const response = await fetch(`${AFFILIATE_API_URL}/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json();
      if (response.ok && data.affiliate) {
        setCodeAff(data.affiliate.code_aff);
        setNewCode(data.affiliate.code_aff);
      }
    } catch (err) {
      setError('Erreur lors de la récupération du code.');
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    try {
      const response = await fetch(`${AFFILIATE_API_URL}/updateaffcode`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ code_aff: newCode }),
      });
      const data = await response.json();
      if (response.ok) {
        setMessage('Code de parrainage mis à jour !');
        setCodeAff(newCode);
      } else {
        setError(data.message || 'Erreur lors de la mise à jour.');
      }
    } catch (err) {
      setError('Erreur réseau : ' + err.message);
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-100 bg-gradient-to-br from-slate-950 via-black to-slate-950">
        <div className="p-8 bg-white/5 border border-white/10 rounded-lg">
          <p>Veuillez vous connecter à l'espace affiliation.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center text-slate-100 bg-gradient-to-br from-slate-950 via-black to-slate-950 p-4">
      <div className="w-full max-w-md p-8 bg-white/5 border border-white/10 rounded-lg">
        <h1 className="text-2xl font-bold mb-4">Modifier mon lien de parrainage</h1>
        <form onSubmit={handleUpdate} className="space-y-4">
          <div>
            <label className="block text-sm mb-2">Code actuel</label>
            <input
              type="text"
              value={codeAff}
              disabled
              className="w-full px-4 py-2 bg-white/10 border border-white/10 rounded-lg text-slate-400"
            />
          </div>
          <div>
            <label className="block text-sm mb-2">Nouveau code</label>
            <input
              type="text"
              value={newCode}
              onChange={e => setNewCode(e.target.value)}
              className="w-full px-4 py-2 bg-white/10 border border-white/10 rounded-lg"
              required
              minLength={3}
              maxLength={32}
            />
          </div>
          {error && <div className="text-red-400 text-sm">{error}</div>}
          {message && <div className="text-green-400 text-sm">{message}</div>}
          <button
            type="submit"
            className="w-full py-2 bg-blue-600 hover:bg-blue-700 rounded-lg font-medium transition-colors"
          >
            Mettre à jour
          </button>
        </form>
      </div>
    </div>
  );
}
